module.exports = __webpack_public_path__ + "img/sec1_7.46294132.png";